module.exports = __webpack_public_path__ + "static/Thumb_H2_SkullFX_FX-3e06c63085b713f10caf94db24e38a6b.png";